export const SIZE_STATE_KEYS = {
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs',
};

export const EVENTS_FILTER_KEYS = {
  AREA: 'area',
  DATES: 'dates',
  TYPE: 'type',
  LEVEL: 'level',
  MEMBERS: 'members',
  CONDITIONS: 'conditions',
  GROUP: 'group',
  TAGS: 'tags',
};

export const EVENTS_FILTERS_TYPES = {
  CHIP: 'chip',
  SELECT: 'select',
  CALENDAR: 'calendar',
};

export const REQUEST_STATUSES = {
  REQUEST: 1,
  REJECT: 2,
  ACTIVE: 3,
  RESTRICTED: 4,
  DISQUALIFIED: 5,
  DRAFT_REQUEST: 6,
  INCORRECT_DOCUMENTS: 7,
};

export const REQUEST_DATA_STATUSES = {
  [REQUEST_STATUSES.REQUEST]: {
    text: 'Заявка на рассмотрении',
    icon: '$iclock-outline',
    attrs: {
      color: 'redesignWarning',
    },
  },
  [REQUEST_STATUSES.REJECT]: {
    text: 'Заявка отклонена',
    icon: '$iclose-outline-circle',
    attrs: {
      color: 'redesignError',
    },
  },
  [REQUEST_STATUSES.ACTIVE]: {
    text: 'Заявка принята',
    icon: '$icheck-outline-circle',
    attrs: {
      color: 'redesignSuccess',
    },
  },
  [REQUEST_STATUSES.RESTRICTED]: {
    text: 'Заявка требующая рассмотрения',
    icon: '$ialert',
    attrs: {
      color: 'redesignWarning',
    },
  },
  [REQUEST_STATUSES.DISQUALIFIED]: {
    text: 'Заявка дисквалифицирована',
    icon: '$iclose-outline-circle',
    attrs: {
      color: 'redesignError',
    },
  },
  [REQUEST_STATUSES.DRAFT_REQUEST]: {
    text: 'Заявка не заполнена',
    icon: '$iclock-outline',
    attrs: {
      color: 'redesignSecondary',
    },
  },
  [REQUEST_STATUSES.INCORRECT_DOCUMENTS]: {
    text: 'Заявку необходимо дозаполнить',
    icon: '$ialert',
    attrs: {
      color: 'redesignWarning',
    },
  },
};

export const SEARCH_EVENTS_PROGRESS = {
  future: 1, // дата начала первого этапа >= текущей даты
  current: 2, // дата окончания подачи заявок >= текущей даты
  completed: 3, // максимальная дата окончания этапов <= текущей
  active: 4, // максимальная дата окончания этапов > текущей
};
